import React, { Component } from 'react';
import CollapsablePanel from './CollapsePanel';
import ClientsTableConfiguration from './ClientsTableConfiguration';

class ClientsTableConfigurations extends Component {
    render() {
        let { fields, dispatch } = this.props;

        return <div>
            {fields.map((el, idx, all) => {
                let configuration = all.getAll()[idx];
                return <div key={idx}>
                    <CollapsablePanel configuration={'configuration' + idx} section={'configuration' + idx} title={`Tablet #${idx + 1}`}>
                        <ClientsTableConfiguration dispatch={dispatch} configuration={configuration} el={el} idx={idx} onClick={() => fields.remove(idx)} />
                    </CollapsablePanel>
                </div>
            })}
            <br />

            <button className="btn btn-sm btn-primary"  title="Configure a new Tablet" onClick={() => fields.push({
                apiKey: ``,
                url: `https://app.klienditahvel.ee/tablet/cart`,
                locationId: -1,
            })}><i className="widget-add-item fa fa-plus-circle" ></i>{""} Add tablet</button>
        </div>
    }
}

export default ClientsTableConfigurations;



// WEBPACK FOOTER //
// app/containers/ClientsTableConfigurations.jsx